import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { TabIndices } from '@/common/i-doc/i-doc.registry.ts';
import { PageHint } from '@components/common/PageHint.tsx';
import { FinanceLegacyOptions } from '@services/finance-legacy.service.ts';

// Довідник джерел доходу/витрати (entry_sources) - простий перелік, дані
// вже завантажені на рівні сторінки разом з рештою options, не дублюємо запит.
export const FinanceLegacySourcesTab: React.FC<{ options: FinanceLegacyOptions }> = ({ options }) => (
  <Box data-i-doc={TabIndices.DEV_FINANCE_LEGACY_SOURCES}>
    <PageHint iDoc={TabIndices.DEV_FINANCE_LEGACY_SOURCES} />

    {options.sources.length === 0 ? (
      <Typography sx={{ mt: 4, textAlign: 'center' }}>Джерел не знайдено.</Typography>
    ) : (
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Назва</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {options.sources.map((source) => (
              <TableRow key={source.value}>
                <TableCell>{source.value}</TableCell>
                <TableCell>{source.label}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </Box>
);
